import { Meet } from "./Meet";
class GhesEndpoint extends Meet {
    constructor() {
        super("/Ghes");
    }
    deleteGhe(id) { return this.DeleteAUTH(`(${id})`, { noLoading: true }) }

}
export default new GhesEndpoint();